/*
 *
 * LegalRepPEPModal
 *
 * @version 1.0.0
 * @author Pietro Bertuccelli
 * @since 09-Sep-2024
*/

import { connect } from 'react-redux'
import LegalRepPEPModal from './LegalRepPEPModal'
// import { nullSafe } from 'Utility/globalMethods'
import { doHidePopup } from 'Store/actions/popup'

const mapDispatchToProps = dispatch => ({
  doHidePopup: () => dispatch(doHidePopup())
})

const mapStateToProps = () => ({
})

export default connect(mapStateToProps, mapDispatchToProps, (stateProps, dispatchProps, mergeProps) => ({
  ...stateProps,
  ...mergeProps,
  actions: dispatchProps
}))(LegalRepPEPModal)
